<template>
  <div class="general-info">
    <section-title :has-line="true" title="Información General" />
    <div class="bg-secondary-3 rounded  pt-2 pb-3 px-4">
      <div v-if="readMode">
        <div class="row bg-white p-3 rounded mb-2">
          <div class="col-12  col-md-3 mb-3">
            <div class="general-info__label">
              <em
                class="general-info__label_icon fas fa-ballot-check text-orange"
              />
              Estatus:
            </div>
            <span class="general-info__info">
              {{ records.status.name }}
            </span>
          </div>
          <div class="col-12  col-md-3 mb-3">
            <div class="general-info__label">
              <em
                class="general-info__label_icon fas fa-ballot-check text-orange"
              />
              Número de Hallazgo:
            </div>
            <span class="general-info__info">
              {{ records.monitoringNo }}
            </span>
          </div>
          <div class="col-12  col-md-3 mb-3">
            <div class="general-info__label">
              <em
                class="general-info__label_icon fas fa-ballot-check text-orange"
              />
              Creado por:
            </div>
            <span class="general-info__info">
              {{ records.createdByUser }}
            </span>
          </div>
          <div class="col-12  col-md-3 mb-3">
            <div class="general-info__label">
              <em class="general-info__label_icon fa fa-calendar text-orange" />
              Fecha:
            </div>
            <span class="general-info__info">
              {{ records.findingDate | date }}
            </span>
          </div>
          <div class="col-12  col-md-4 mb-3">
            <div class="general-info__label">
              <em
                class="general-info__label_icon fas fa-ballot-check text-orange"
              />
              Hallazgo:
            </div>
            <span class="general-info__info">
              {{ records.reason.name }}
            </span>
          </div>
        </div>

        <div class="row p-3 rounded mb-2">
          <div class="col-12 mt-md-3">
            <custom-text-area
              id="comment"
              v-model="records.comment"
              :disabled="readMode"
              label="Comentario:"
              :maxlength="500"
              name="comment"
              :rows="3"
              :show-char-count="false"
              @input="onCommentChange"
            />
          </div>
        </div>
      </div>

      <validation-observer
        v-if="!readMode"
        ref="umesrDetailsFormGeneralInfo"
        tag="form"
      >
        <div class="row bg-white p-3 rounded mb-2">
          <div class="col-12 col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="records.findingDate"
                class="w-100"
                :class-container="''"
                custom-error-msg="Favor seleccionar fecha."
                :disabled="readMode"
                :error="errors[0]"
                label="Fecha de Hallazgo:"
                :max-date="new Date()"
                placeholder="DD/MM/YYYY"
                @onSelectedDate="onSelectedDate"
              />
            </validation-provider>
          </div>

          <div class="col-12 col-md-5">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="records.reason"
                custom-error-msg="Favor seleccionar el tipo de hallazgo."
                :disabled="readMode"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Hallazgo:"
                :options="reasons"
                placeholder="Seleccione"
                :value="records.reasonId"
                @input="onActivityChange"
              />
            </validation-provider>
          </div>
          <div class="col-12 mt-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                id="comment"
                v-model="records.comment"
                custom-error-msg="Favor escriba un comentario."
                :disabled="readMode"
                :error="errors[0]"
                label="Comentario:"
                :maxlength="500"
                name="comment"
                :rows="3"
                :show-char-count="true"
                @input="onCommentChange"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import { getCodeExemptionFindingType } from '@/modules/umesr/api';

const recordsDefault = {
  reasonId: null,
  comment: '',
  reason: null,
  status: {},
};

export default {
  components: {
    SectionTitle,
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    records: { ...recordsDefault },
    reasons: [],
    readMode: true,
  }),
  watch: {
    disabled: {
      immediate: true,
      handler() {
        this.readMode = Boolean(this.disabled);
      },
    },
    data: {
      immediate: true,
      async handler(current) {
        const records = {
          ...recordsDefault,
          ...current,
        };

        this.records = { ...records };
      },
    },
  },
  created() {
    getCodeExemptionFindingType().then((x) => (this.reasons = [...x.data]));
  },
  methods: {
    onActivityChange(data) {
      if (data.id) {
        this.records.reasonId = Number(data?.id);
        this.$emit('change', { ...this.records });
      }
    },
    onSelectedDate(date) {
      this.records.findingDate = date;
      this.$emit('change', { ...this.records });
    },
    onCommentChange(comment) {
      this.records.comment = String(comment);
      this.$emit('change', { ...this.records });
    },
  },
};
</script>
<style lang="scss" scoped>
.general-info {
  &__label {
    font-weight: normal;
    font-size: 14px;
    color: #727272;

    &_icon {
      margin-left: -0.9rem;
    }
  }

  &__info {
    font-weight: normal;
    font-size: 16px;
    color: #11291b;
  }
}
</style>
